import { Serializable } from "@/core/api/decorators/serializable_decorator"
import {
  PriceCategoryBaseModel,
  PriceCategoryBaseData,
} from "./priceCategoryBaseModel"
import { PriceType } from "../../constants/priceType"
import { IsNumber, IsPositive } from "class-validator"
import { IsUnder } from "@/modules/tasks/core/utils/validators/isUnder"

@Serializable
export class PriceCategoryIntervalModel extends PriceCategoryBaseModel {
  priceType: PriceType.Interval = 3
  @IsNumber(
    { allowNaN: false, allowInfinity: false, maxDecimalPlaces: 0 },
    {
      message: "form.errors.empty",
      groups: ["create_category"],
    },
  )
  minAmount: number = 0
  @IsNumber(
    { allowNaN: false, allowInfinity: false, maxDecimalPlaces: 0 },
    {
      message: "form.errors.empty",
      groups: ["create_category"],
    },
  )
  @IsUnder("minAmount", {
    message: "price_interval_error",
    groups: ["price_table"],
  })
  @IsPositive({
    message: "price_interval_max_error",
    groups: ["price_table"],
  })
  maxAmount: number = 0

  constructor(
    data:
      | (Omit<PriceCategoryBaseData, "priceType"> & {
          priceType: PriceType.Interval
          minAmount: number
          maxAmount: number
          numConsultants?: number
          hourlyRateOverwrite?: number
        })
      | null = null,
  ) {
    super(data)
    if (data) {
      this.minAmount = data.minAmount
      this.maxAmount = data.maxAmount
    }
  }
}
